import { render, staticRenderFns } from "./editable-table.vue?vue&type=template&id=63eb4a34&scoped=true"
import script from "./editable-table.vue?vue&type=script&lang=ts"
export * from "./editable-table.vue?vue&type=script&lang=ts"
import style0 from "./editable-table.vue?vue&type=style&index=0&id=63eb4a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eb4a34",
  null
  
)

export default component.exports